var exports = {
  "ne": "xdbfd91f1--ee34c1--controls",
  "mR": "xdbfd91f1--ee34c1--left_block",
  "Bj": "xdbfd91f1--ee34c1--right_block",
  "BP": "xdbfd91f1--ee34c1--right_block_fat",
  "W5": "xdbfd91f1--ee34c1--arrow_left",
  "B7": "xdbfd91f1--ee34c1--arrow_right",
  "Y5": "xdbfd91f1--ee34c1--fullscreen",
  "hJ": "xdbfd91f1--ee34c1--counter",
};

module.exports = exports;
